let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("684pV")).then(() => parcelRequire('6B7lH'));